import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

type ModalProps = {
  toggle: boolean
  setToggle: React.Dispatch<React.SetStateAction<boolean>>
  title: string
  description: string | React.ReactNode
  afterLeave?: () => void
  children: React.ReactNode
}

const Modal: React.FC<ModalProps> = ({
  setToggle,
  toggle,
  children,
  description,
  title,
  afterLeave,
}) => (
  <Transition.Root show={toggle} as={Fragment}>
    <Dialog
      as="div"
      className="fixed z-50 inset-0 overflow-y-auto"
      onClose={setToggle}
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={afterLeave}
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enterTo="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full p-6">
            <div className="mb-4">
              <p className="text-lg font-normal text-gray-800 mb-2">{title}</p>
              <p className="light-text">{description}</p>
            </div>
            {children}
          </div>
        </Transition.Child>
      </div>
    </Dialog>
  </Transition.Root>
)

export default Modal
